/**
 * Der Neuladen-Knopf („Neue Version“) in der Kopfleiste.
 *
 * Er erscheint NUR, wenn ein Update bereitliegt (Martin 17.10.2026, 12:44: „Der Reload-Button oben
 * soll nur dann kommen, wenn es ein Update gibt.“) und ist im Anruf verborgen. Ohne Update gibt es
 * ihn nicht — keinen „ruhigen“ Dauer-Zustand. Der Klick lädt die neue Version.
 *
 * ⚠️ Das Wort bleibt im DOM (nur für Vorleser sichtbar, CSS .app-update-pill-wort) — ein Knopf nur mit Zeichen
 *    ist für jemanden mit Vorleser ein leerer Knopf.
 */
import { zeichen } from "./zeichen.js";

const BEREIT_WORT = "Neue Version";
const BEREIT_NAME = "Neue Version laden";
const LAEUFT_WORT = "Aktualisiere …";

export interface NeuladenKnopf {
  knopf: HTMLButtonElement;
  /** Sichtbar nur bei `bereit` (Update liegt an) und nicht `verborgen` (Anruf läuft). */
  zeige(bereit: boolean, verborgen: boolean): void;
}

export function erzeugeNeuladenKnopf(opts: { neuLaden: () => void }): NeuladenKnopf {
  const knopf = document.createElement("button");
  knopf.type = "button";
  knopf.className = "app-update-pill";
  // ⚠️ Fest: eine App, die ihre eigene Erneuerung nicht anbieten kann, hängt auf einem alten Stand fest
  //    (gemessen am 22.09.) — und ein Neuladen-Knopf, der bei Enge weicht, ist keiner.
  knopf.dataset.kopfFest = "1";
  const wort = document.createElement("span");
  wort.className = "app-update-pill-wort";
  wort.textContent = BEREIT_WORT;
  const sinnbild = document.createElement("span");
  sinnbild.className = "app-update-pill-zeichen";
  sinnbild.setAttribute("aria-hidden", "true");
  sinnbild.innerHTML = zeichen("laden", 20);
  knopf.append(sinnbild, wort);
  knopf.hidden = true;
  knopf.setAttribute("aria-label", BEREIT_NAME);
  knopf.title = BEREIT_NAME;

  knopf.addEventListener("click", () => {
    // Ehrliche Rückmeldung: ohne sie sieht der Klick aus, als wäre nichts passiert.
    wort.textContent = LAEUFT_WORT;
    knopf.disabled = true;
    opts.neuLaden();
  });

  return {
    knopf,
    zeige(bereit, verborgen) {
      knopf.hidden = !bereit || verborgen;
      if (knopf.disabled) return; // läuft gerade: Text und Name nicht überschreiben
      wort.textContent = BEREIT_WORT;
    },
  };
}
